import { useQuery } from "@tanstack/react-query";
import fetchToBackend from "@/utils/fetchToBackend";
import { adminKeys } from "@/lib/query-keys";
import type { AdminMetrics } from "@/types/domain";

/** Métricas de negocio del panel de administración para los últimos `days` días. */
export function useAdminMetrics(days: number) {
  return useQuery({
    queryKey: adminKeys.metrics(days),
    queryFn: () => fetchToBackend<AdminMetrics>(`/admin/metrics?days=${days}`),
  });
}
